package com.oasisfeng.invaluable.identity

import org.khronos.webgl.Uint8Array

@JsModule("tweetnacl")
@JsNonModule
private external val nacl: dynamic

actual object SecureRandom {
    actual fun bytes(size: Int): ByteArray {
        val random = nacl.randomBytes(size) as Uint8Array
        val out = ByteArray(size)
        val dyn = random.asDynamic()
        for (i in 0 until size) out[i] = (dyn[i] as Int).toByte()
        return out
    }
}
